var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatSquiggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 93,
    viewBox: "0 0 224 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.297 10.9785C6.12169 15.0045 8.59017 21.3901 13.8087 23.6862C20.4282 26.5988 26.7278 27.1248 33.842 27.1248C40.7566 27.1248 53.3508 25.6313 58.0613 19.5749C68.9165 5.61824 48.1008 -2.75395 38.626 6.19444C28.7885 15.4854 39.5121 28.1603 45.9517 34.5999C55.2756 43.9238 65.6772 39.2344 77.6461 39.2344C92.966 39.2344 108.384 39.7812 123.693 39.2344C130.027 39.0082 136.303 37.8889 142.829 37.8889C152.461 37.8889 160.98 39.7797 170.412 40.5052C182.45 41.4312 192.311 52.0705 200.088 60.7628C206.41 67.828 214.889 79.7228 214.889 89.0187",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.001 84.3679C207.891 84.8394 208.715 85.4726 209.595 85.9818C210.387 86.4409 210.639 87.2281 211.281 87.8696C212.368 88.9575 214.147 91.0139 215.69 91.3568C216.558 91.5498 217.161 87.7549 217.434 87.1635C217.699 86.5889 218.45 86.2844 218.817 85.7225C219.091 85.3041 219.286 84.9343 219.48 84.4976C219.945 83.452 221.387 83.2292 221.786 82.0334",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatSquiggle);
export default __webpack_public_path__ + "static/media/feat-squiggle.1bcab5973da150103cd6acb292794d14.svg";
export { ForwardRef as ReactComponent };